/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Committedorganisations_Commitment2Inputs */

const en_coinvestments_report_committedorganisations_commitment2 = /** @type {(inputs: Coinvestments_Report_Committedorganisations_Commitment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commitment`)
};

/**
* | output |
* | --- |
* | "Commitment" |
*
* @param {Coinvestments_Report_Committedorganisations_Commitment2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_committedorganisations_commitment2 = /** @type {((inputs?: Coinvestments_Report_Committedorganisations_Commitment2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Committedorganisations_Commitment2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_committedorganisations_commitment2(inputs)
});
export { coinvestments_report_committedorganisations_commitment2 as "coInvestments_report_committedOrganisations_commitment" }